<template>
  <v-row>
    <v-col cols="12" class="mb-6">
      <!--
        multiple = true permette di aprire più pannelli contemporaneamente.
        v-model="panelData" è un array di indici dei pannelli aperti.
      -->
      <v-expansion-panels
          v-model="panelData"
          multiple
          @change="onPanelsChange"
      >
        <!-- Cicliamo l'array items e creiamo un pannello per ciascuno -->
        <v-expansion-panel
            v-for="(item, idx) in items"
            :key="idx"
        >
          <!-- Header unico con titolo dinamico in base a se il pannello idx è aperto -->
          <v-expansion-panel-header>
            {{ panelData.includes(idx) ? item.title_open : item.title }}

            <!-- Icona a destra -->
            <template v-slot:actions>
              <v-icon color="AXABlue">keyboard_arrow_down</v-icon>
            </template>
          </v-expansion-panel-header>

          <!-- Contenuto espanso -->
          <v-expansion-panel-content>
            <v-row
                v-for="(row, rindex) in item.rows"
                :key="rindex"
            >
              <v-col cols="12" class="text-center text-md-left">
                <v-row>
                  <v-col cols="12" md="2">
                    <v-avatar>
                      <img :src="row.image" alt="">
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="10">
                    <h4 class="title" v-html="row.title"></h4>
                    <div v-html="row.text"></div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: "PremioAccordionAXA",

  data() {
    return {
      // Array di indici dei pannelli aperti
      panelData: [],
      // Teniamo traccia del valore "precedente" per capire se stiamo aprendo/chiudendo
      oldPanelData: []
    };
  },

  computed: {
    ...mapState({
      // items: array di oggetti con { title, title_open, rows: [...] }
      items: (state) => state.premio.items,
    }),
    ...mapGetters({
      getPanelOpen: "params/getPanelOpen"
    })
  },

  mounted() {
    // Se nel tuo store salvi l'array di pannelli aperti,
    // inizializziamo panelData da lì (altrimenti rimane vuoto).
    // Se "getPanelOpen" fosse un singolo numero (caso multiple=false),
    // adattalo di conseguenza.
    this.panelData = Array.isArray(this.getPanelOpen)
        ? this.getPanelOpen
        : []
    // Inizializziamo oldPanelData
    this.oldPanelData = [...this.panelData]
  },

  methods: {
    ...mapMutations({
      setPanelOpen: "params/setPanelOpen"
    }),

    onPanelsChange(newVal) {
      // Esempio: tracciare solo se l'utente sta aprendo un nuovo pannello
      // (cioè la lunghezza di newVal è maggiore di oldPanelData)
      if (newVal.length > this.oldPanelData.length) {
        // Tracking
        window.tc_events_global(this, 'xt_click', {
          'level_2_number': 'AXA_PerNoi',
          'click_name': 'Più_info',
          'click_type': sessionStorage.getItem('sessionId')
        });
      }

      // Aggiorniamo lo store con il nuovo array di pannelli aperti
      this.setPanelOpen(newVal);

      // Aggiorniamo oldPanelData
      this.oldPanelData = [...newVal];
    }
  }
};
</script>
